<template>
  <Row v-if="!isGroup" :gutter="24">
    <Col :span="item.editSpan || 12" v-for="(item, index) in filterFun(list, type + 'Display')" :key="index">
      <template v-if="type === 'detail'">
        <h4 class="title">{{ item.title }}</h4>
        <template v-if="item.slot">
          <slot :name="item.dataIndex"></slot>
        </template>
        <p v-else class="content">
          {{ formaterFun(item, data) || '--' }}
        </p>
      </template>
      <template v-else>
        <FormItem :name="item.dataIndex" :label="item.title" :rules="item.rules" :required="item.required">
          <SearchFormItem :searchParam="data" :item="item">
            <template #[item.dataIndex]>
              <slot v-bind="{ item }" :name="item.dataIndex"></slot>
            </template>
          </SearchFormItem>
        </FormItem>
      </template>
    </Col>
  </Row>
  <template v-else>
    <Row v-for="(item, index) in filterFun(list, type + 'Display')" :key="index" :gutter="24">
      <Col :span="24" class="group-title">{{ item.title }}</Col>
      <template v-if="item.slot">
        <slot :name="item.dataIndex"></slot>
      </template>
      <template v-else-if="type === 'detail'">
        <Col :span="k.detailSpan || 12" v-for="(k, i) in filterFun(item.column, 'detailDisplay')" :key="i">
          <h4 class="title">{{ k.title }}</h4>
          <p class="content" v-if="!k.slot">{{ formaterFun(k, data) || '--' }}</p>
          <template v-else>
            <slot :name="k.dataIndex + 'view'"></slot>
          </template>
        </Col>
      </template>
      <template v-else>
        <Col :span="k.editSpan || 12" v-for="(k, i) in filterFun(item.column, 'editDisplay')" :key="i">
          <FormItem :name="k.dataIndex" :label="k.title" :rules="k.rules" :required="k.required">
            <SearchFormItem :searchParam="data" :item="k">
              <template #[k.dataIndex]>
                <slot v-bind="{ k }" :name="k.dataIndex"></slot>
              </template>
            </SearchFormItem>
          </FormItem>
        </Col>
      </template>
    </Row>
  </template>
</template>
<script lang="ts" setup name="Detais">
  import { Row, Col, FormItem } from 'ant-design-vue'
  import SearchFormItem from '@/components/searchForm/SearchFormItem.vue'

  interface IListProps {
    list: Record<string, any>[]
    data: Record<string, any>
    isGroup: boolean
    type: string
  }
  defineProps<IListProps>()
  const filterFun = (arr: Record<string, any>[], type: string) => {
    return arr.filter((item: Record<string, any>) => item[type] !== false)
  }
  const formaterFun = (item: Record<string, any>, data: Record<string, any>) => {
    return typeof item.formater === 'function'
      ? item.formater({ text: data[item.dataIndex] || '', record: data })
      : data[item.dataIndex]
  }
</script>
<style scoped>
  .title {
    color: #808080;
  }
  .content {
    color: #3c3c3c;
  }
  .group-title {
    color: #3c3c3c;
    font-size: 16px;
    font-weight: 600;
    margin: 20px 0 10px;
  }
</style>
